import i18n from 'src/i18n/index.js';

class MedicalSelection {
  constructor(params) {
    this.policyNumber = params.policyNumber;
    this.orthodonticsWithinTwoYears = params.orthodonticsWithinTwoYears;
    this.dentistLastTwoYears = params.dentistLastTwoYears;
    this.hasCongenitalDentalDefect = params.hasCongenitalDentalDefect;
    this.congenitalDentalDefectMessage = params.congenitalDentalDefectMessage;
    this.extracted4OrMoreTeeth = params.extracted4OrMoreTeeth;
    this.numberOfMissingTeeth = params.numberOfMissingTeeth;
    this.expectsToHaveOneOfFollowingTreatments = params.expectsToHaveOneOfFollowingTreatments;
    this.doesNotExpectTreatment = params.doesNotExpectTreatment;
    this.acceptedTermsAndConditions = params.acceptedTermsAndConditions;
    this.acceptanceDate = params.acceptanceDate;
  }

  static createEmpty() {
    return new MedicalSelection({
      policyNumber: null,
      orthodonticsWithinTwoYears: null,
      dentistLastTwoYears: null,
      hasCongenitalDentalDefect: null,
      congenitalDentalDefectMessage: '',
      extracted4OrMoreTeeth: null,
      numberOfMissingTeeth: 0,
      expectsToHaveOneOfFollowingTreatments: [],
      doesNotExpectTreatment: false,
      acceptedTermsAndConditions: false,
      acceptanceDate: undefined,
    });
  }

  static createEmptyNew() {
    return new MedicalSelection({
      policyNumber: null,
      orthodonticsWithinTwoYears: null,
      dentistLastTwoYears: null,
      hasCongenitalDentalDefect: null,
      congenitalDentalDefectMessage: '',
      extracted4OrMoreTeeth: null,
      numberOfMissingTeeth: 0,
      expectsToHaveOneOfFollowingTreatments: [
        {
          key: 0,
          value: i18n.global.t('edit-policy.labels.make-choice'),
        },
      ],
      doesNotExpectTreatment: false,
      acceptedTermsAndConditions: true,
      acceptanceDate: undefined,
    });
  }

  getDenialReasons() {
    const denialReasons = [];
    if (this.orthodonticsWithinTwoYears)
      denialReasons.push(i18n.global.t('medical-selection.denial.orthodontics-within-two-years'));
    if (!this.dentistLastTwoYears) denialReasons.push(i18n.global.t('medical-selection.denial.dentist-last-two-years'));
    if (this.hasCongenitalDentalDefect)
      denialReasons.push(i18n.global.t('medical-selection.denial.has-congenital-dental-defect'));
    if (this.extracted4OrMoreTeeth)
      denialReasons.push(i18n.global.t('medical-selection.denial.extracted-4-or-more-teeth'));
    if (!this.doesNotExpectTreatment)
      denialReasons.push(i18n.global.t('medical-selection.denial.does-expect-treatment'));
    return denialReasons;
  }
}
export { MedicalSelection as default };
